import { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export type DiscountCodeSource = 'state' | 'query';

export interface PendingDiscountCodeInfo {
  code: string;
  autoApply: boolean;
  source: DiscountCodeSource;
}

const DISCOUNT_CODE_QUERY_KEY = 'discountCode';

export const useDiscountCodeDeepLink = (): PendingDiscountCodeInfo | null => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const stateCode = (location.state as { discountCode?: string } | null)?.discountCode;
  const queryCode = searchParams.get(DISCOUNT_CODE_QUERY_KEY);

  const info = useMemo<PendingDiscountCodeInfo | null>(() => {
    if (stateCode) {
      return { code: stateCode, autoApply: true, source: 'state' };
    }
    if (queryCode) {
      return { code: queryCode, autoApply: false, source: 'query' };
    }
    return null;
  }, [stateCode, queryCode]);

  useEffect(() => {
    if (!stateCode && queryCode) {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.delete(DISCOUNT_CODE_QUERY_KEY);
          return next;
        },
        { replace: true },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryCode]);

  return info;
};
